<div class="min-h-screen layout flex flex-column">
  <shared-navbar/>
  <div class="flex-1">
    <router-outlet></router-outlet>
  </div>
</div>